import * as React from 'react'
import { cn } from '../../utils/lib/utils'
import PropTypes from 'prop-types'

export const Flex = React.forwardRef(({ 
  children,
  direction = 'row',
  align = 'stretch',
  justify = 'start',
  gap,
  className,
  ...props 
}, ref) => {
  const gapClass = gap ? `gap-${gap}` : ''
  
  return (
    <div
      ref={ref}
      className={cn(
        'flex',
        `flex-${direction}`,
        `items-${align}`,
        `justify-${justify}`,
        gapClass,
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
})

Flex.propTypes = {
  children: PropTypes.node,
  direction: PropTypes.oneOf(['row', 'col', 'row-reverse', 'col-reverse']),
  align: PropTypes.oneOf(['start', 'end', 'center', 'baseline', 'stretch']),
  justify: PropTypes.oneOf(['start', 'end', 'center', 'between', 'around', 'evenly']),
  gap: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string
}

Flex.displayName = 'Flex' 